<template>
  <div class="segment-publish-panel">
    <div class="segment-publish-panel__header">
      <span>发布文案</span>
      <el-switch
        :value="enabled"
        :disabled="disabled"
        @input="$emit('update:enabled', $event)"
      />
    </div>
    <p class="segment-publish-panel__hint">
      切片完成后可导出「发布素材包」并在各平台创作者中心手动上传。{{ descriptionHint }}
    </p>
    <div v-if="enabled" class="segment-publish-panel__body">
      <el-form label-width="88px" size="small" :disabled="disabled">
        <el-form-item label="话题标签">
          <el-input
            :value="hashtags"
            placeholder="#电影解说 #影视剪辑"
            maxlength="512"
            show-word-limit
            @input="$emit('update:hashtags', $event)"
          />
        </el-form-item>
        <el-form-item label="简介模板">
          <el-input
            :value="descriptionTemplate"
            type="textarea"
            :rows="3"
            placeholder="第{index}集：{title}"
            maxlength="1024"
            show-word-limit
            @input="$emit('update:descriptionTemplate', $event)"
          />
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { PUBLISH_DESCRIPTION_HINT } from '../constants/publishPlatforms';

export default {
  name: 'SegmentPublishPanel',
  props: {
    enabled: { type: Boolean, default: false },
    hashtags: { type: String, default: '' },
    descriptionTemplate: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      descriptionHint: PUBLISH_DESCRIPTION_HINT,
    };
  },
};
</script>

<style scoped>
.segment-publish-panel {
  margin-top: 16px;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fafafa;
}
.segment-publish-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  font-size: 14px;
}
.segment-publish-panel__hint {
  margin: 8px 0 0;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.5;
}
.segment-publish-panel__body {
  margin-top: 12px;
}
</style>
